<template>
  <div class="input-wrapper">
    <div class="input-label">
      
    </div>
    <div class="input-block" :class="{ invalid: errors.has(name) }">
      <input
        class="input"
        type="number"
        v-model="inputValue"
        :name="name"
        @input="$emit('input', inputValue)"
        @paste="$emit('input', inputValue)"
        v-validate="validateRules"
        ref="password"
        :placeholder="placeholder"
        :disabled="disabled"
      />
    </div>
    <div class="error-block">{{ errorMessage }}</div>
  </div>
</template>

<script>
export default {
  name: 'BasePaymentInput',
  props: {
        name: String,
        validateRules: String,
        placeholder: String,
        disabled: Boolean
    },
    data() {
        return {
            inputValue: '',
        }
    },
    computed: {
        errorMessage() {
            return this.errors.first(this.name);
        }
    }
}
</script>

<style lang="scss" scoped>
.input-wrapper {
    @include base-input-wrapper;
}

.input-label {
    @include base-input-label;
}

.input-block {
    @include base-input-block;
    display: flex;
    align-items: center
}

.input {
    @include base-input;
    font-family: 'Open Sans', sans-serif;
}

.eye-img {
    height: 32px;
    width: 32px;
    cursor: pointer;
}

.invalid {
    border-color: var(--base-input-invalid-border-bgc);
}

.error-block {
    @include base-input-error-block;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
    -moz-appearance:textfield; /* Firefox */
}
</style>